import React from 'react';

const FormGroup = ({ children, className = '' }) => {
  let classes = 'v2-form__group';

  if ( className ) {
    classes += ` ${className}`;
  }

  return <div className={classes}>{children}</div>;
};

export default FormGroup;
